import axios from "axios";

export default {
    getArchivedProducts: async (companyId) => {
        const { data } = await axios.get(`/products/archive/${companyId}`)

        return data
    },
    restoreArchivedProducts: async (companyId, productIds) => {
        await axios.post(`/products/archive/${companyId}/restore`, {
            product_ids: productIds
        })
    }
}
